import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtility } from '@app/_modules/commonUtility';
import { CategoryService } from '@app/_services/category.service';
import { retryWhen } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { SweetAlertService } from '@app/_services/sweet-alert.service';
//import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
//import { SweetAlertService } from 'ngx-sweetalert2';


@Component({
  selector: 'app-trimble-fee-details',
  templateUrl: './trimble-fee-details.component.html',
  styleUrls: ['./trimble-fee-details.component.less']
})
export class TrimbleFeeDetailsComponent implements OnInit {

  //displayedColumns: string[] = ['Srno','Contract No','Customer Name','Paymeent Amount'];

  form: FormGroup;
  forms: FormGroup;
  JSON;
  isgPay_url:string;
  todayDate:Date;

  @ViewChild('txnForm') txnForm: any;
  tranxnForm : FormGroup;
  submitBtnMsg:String;
  submitBtnMsgClass:String = 'wrappper';
  commonUtility:CommonUtility;
  loading = false;
  name:any='';
  initialCap: any;
  submitted = false;
  fathersName:any='';
  courseLoader = false;
  course:any;
  semester:any;
  semesterList:any;
  source:any;
  type:any='';
  req : any;
  amount:any;
  row:any='';
  contractNo:any;
  panNo:any;
  customerName:any;
  totalAmount:any;
  contractName:any;
  myDIV: Boolean = false ;
  dataSource:any;
  disableSelect;
  totalFees:any;
  EncDataField:string;
  MerchantIdField:string;
  TransactionId:string;
  BankIdField:string;
  TerminalIdField:string;
  VersionField:string;
  showTable: Boolean = false ;
  totalDisabled:boolean=true;
  verified: boolean = false;
  isVerificationPending: boolean = true;
  isVerified: boolean = false;
  studentData:any;
  resStatusCode;
  termsAccepted: boolean = false;
  invoiceAmount; 
  checkboxValue: boolean = false;
  formSubmitted: boolean = false;
  dialogRef: any;
  isPopupVisible = false;
  // Email:string;
  // Phone:string;
  // FirstName:string;
  // LastName:string;
  emailId:string;
  mobileNo:string;
  firstName:string;
  lastName:string;


  constructor(
    private sweetalert:SweetAlertService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private categoryService: CategoryService,
    public dialog: MatDialog,
  //  private sweetalert: SweetAlertService
  ) {
    this.JSON=JSON;
    this.isgPay_url = categoryService.isgPay_url;
    this.commonUtility = this.categoryService.commonUtility;

   }



openTermsAndConditionsPopup(event: Event) {
  // Prevent default action of the hyperlink
  event.preventDefault();

  // Display Sweet Alert to show terms and conditions
  this.sweetalert.errorAlert('Terms & Conditions', `
  <html>
  <div style="font-size: 16px; text-align: left;">
      <p>These terms and conditions apply to the Customer who uses this Online Payment Services for the purchase of Software licenses from Trimble Solutions India Private Ltd. Please read these terms and conditions carefully. By authorizing a payment to Trimble Solutions India Private Ltd through this online payment service (“the service”), it would be treated as a deemed acceptance of these terms and conditions. Trimble Solutions India Private Ltd reserves all the rights to amend these terms and conditions at any time without giving prior notice. It is the responsibility of the Customer to read the terms and conditions before using the Service.</p>
      <h2>Key Terms:</h2>
      <p>The key terms of this service can be accessed from:</p>
      <ul>
          <li><a href="https://www.tekla.com/terms-of-sale">https://www.tekla.com/terms-of-sale</a></li>
          <li><a href="https://www.tekla.com/terms-and-conditions">https://www.tekla.com/terms-and-conditions</a></li>
      </ul>
      <p>Payment(s) through this Service may only be made with a Credit Card/Debit Card, Wallets, and UPI (Unified Payments Interface) & UPI QR Code hereafter referred as online payment methods.</p>
      <p>Before using this Service, it is recommended that the Customer shall review the charges or fees payable against the available online payment methods and verify the amount payable to Trimble Solutions India Private Ltd.</p>
      <p>The online payment method information supplied at the time of using the service is processed by the payment gateway of the service provider and is not supplied to Trimble Solutions India Private Ltd. It is the sole responsibility of the Customer to ensure that the information entered in the relevant fields are correct. It is recommended that you take and retain a copy of the Transaction Acknowledgement for record-keeping purposes, which might assist in resolution of any disputes that may arise on usage of this service.</p>
      <p>The Customer agrees, understands and confirms that his/ her personal data including without limitation details relating to online payment methods is transmitted over the Internet Payment Gateway may be susceptible to misuse, hacking, theft and/ or fraud and that Trimble Solutions India Private Ltd or the Payment Service Provider(s) have no control over such matters.</p>
      <p>The service is provided using a Payment Gateway Service Provider through a secure website. However, neither the payment gateway service provider nor Trimble Solutions India Private Ltd gives any assurance, that the information so provided online by the Customer is secured or may be read or intercepted by a third party. Trimble Solutions India Private Ltd does not accept or assume any liability in the event of such unauthorized interception, hacking or other unauthorized access to information provided by a Customer for usage of this service.</p>
      <p>Trimble Solutions India Private Ltd and/or the Payment Service Providers shall not be liable for any inaccuracy, error or delay in, or omission of (a) any data, information or message, or (b) the transmission or delivery of any such data, information or message; or (c) any loss or damage arising from or occasioned by any such inaccuracy, error, delay or omission, non-performance or interruption in any such data, information or message. Under no circumstances shall Trimble Solutions India Private Ltd and/or the Payment Service Providers, its employees, directors, and its third party agents involved in processing, delivering or managing the Services, be liable for any direct, indirect, incidental, special or consequential damages, or any damages whatsoever, including punitive or exemplary arising out of or in any way connected with the provision of or any inadequacy or deficiency in the provision of the Services or resulting from unauthorized access or alteration of transmissions of data or arising from suspension or termination of the Service.</p>
      <p>The Customer agrees that Trimble Solutions India Private Ltd or any of its employees will not be held liable for any loss or damages arising from the use of Internet Payment Gateway, or reliance upon the information contained on the Website, or any failure to comply with these Terms and Conditions where such failure is due to circumstance beyond Trimble Solutions India Private Ltd reasonable control.</p>
      <h2>Privacy Policy:</h2>
      <p>The information provided by the user related to online payment methods are not accessed or stored by Trimble Solutions India Private Ltd on this website.</p>
      <p>If payment is made by means of a card/accounts that you do not personally own, the permission of the card owner must always be obtained to make payments using the card and for any such payment.</p>
      <p>No Warranty: The information and materials contained in this site including, graphics, links or other items is provided on “As Is basis” basis by Trimble Solutions India Private Ltd and the payment gateway service provider which tries to provide information accurately and expressly disclaims liability for error or omission in this information and the materials. No representation or warranty of any kind either express or implied, statutory or otherwise with respect to usage of this payment gateway is given by Trimble Solutions India Private Ltd or the payment gateway service provider</p>
      <p>Limitation of Liability: In no event, Trimble Solutions India Private Ltd will be liable for any damage direct or indirect losses or expenses arising in connection with usage of the service or inability to use by any person delay of operation or transaction, computer virus etc.</p>
      <p>The Customer authorizes Trimble Solutions India Private Ltd to exchange, share, part with all information related to the details and transaction history of the Customers to its Affiliates / Subsidiaries / banks / financial institutions / credit bureaus / agencies/participation in any telecommunication or electronic clearing network as may be required by law, customary practice, credit reporting, statistical analysis and credit scoring, verification or risk management and shall not hold Trimble Solutions India Private Ltd liable for use or disclosure of this information.</p>
      <h2>Non – Binding</h2>
      <p>Please note that this privacy policy does not create any contractual or other legal rights in or on behalf of any party, nor is it intended to do so.</p>
      <h2>Prohibited Actions</h2>
      <ul>
        <li>While using this Site, you agree not to, by any means (including hacking, cracking or defacing any portion of the Site) indulge in illegal or unauthorized activities including the following:</li>
        <li>Restrict or inhibit any authorized user from using this Site</li>
        <li>Use the Site for unlawful purposes</li>
        <li>Harvest or collect information about Site users without their express consent</li>
        <li>“Frame” or “mirror” any part of the Site without our prior authorization</li>
        <li>Engage in spamming or flooding</li>
        <li>Transmit any software or other materials that contain any virus, time bomb, or other harmful or disruptive component</li>
        <li>Remove any copyright, trademark or other proprietary rights notices contained in the Site</li>
        <li>Use any device, application or process to retrieve, index, “data mine” or in any way reproduce or circumvent the navigational structure or presentation of the Site</li>
      </ul>
      <h2>Variations to the Terms and Conditions</h2>
      <p>Trimble Solutions India Private Ltd reserves the right to vary these Terms and Conditions from time to time and the current version will be that published on this website. Trimble Solutions India Private Ltd may also make additions/deletions/alterations to the services offered, at its sole discretion. Trimble Solutions India Private Ltd reserves the right to withdraw the service at any time at its discretion and/ or retains the right to change the terms and conditions for Online Payments, without any prior notice.</p>
  </div>
  </html>
`, '');
}


   maxValue(event)
   {
    if(event.target.value && event.target.max)
    {
      if((event.which != 8 && event.which != 46 && event.which != 37 &&event.which != 39 &&event.which != 9))
      {
          if(event.target.value.length>(<number>event.target.max-1))
        {
          event.preventDefault();
        }
      }
    }
   }
  ngOnInit(): void {
   
    this.todayDate = new Date();
    this.tranxnForm = this.formBuilder.group({
    Version:[''],
    TerminalId: [''],
    BankId: [''],
    MerchantId: [''],
    EncData:[''],
    TransactionId:[''],
    // Email:[''],
    // Phone:[''],
    // FirstName:[''],
    // LastName:['']
    emailId:[''],
    mobileNo:[''],
    firstName:[''],
    lastName:['']

         });
      this.form = this.formBuilder.group({

        firstName: ["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]],
        lastName: ["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]],
        emailId : ["",[Validators.pattern("^[A-Za-z0-9]([A-Za-z0-9._%+-]{0,120})+@[A-Za-z0-9-_]+(\\.[A-Za-z]{2,10}){1,2}$"), Validators.maxLength(150)]],
       companyName: ["",[Validators.required]],
       mobileNo : ['', [Validators.required,Validators.pattern("[1-9][0-9]{9}$")]],
       customerId: ["",[Validators.pattern("^[A-Za-z0-9]+$")]],
       invoiceNumber: ["",[Validators.required,Validators.pattern("^[A-Za-z0-9 -]+$")]],
       invoiceAmount: ["",[Validators.required, Validators.pattern("^[0-9]+$")]],
       inrAmount: [""]
       //terms:["",[Validators.required]]

       //captcha: ['', Validators.required]


      });
      
   
      //this.Cap();
  }
  

  get f()
 { return this.form.controls; }

 
      submitTrimbleDetails():void{
        if(!this.form.controls.invoiceAmount.value )
        {
          this.commonUtility.alertMsg('Please Enter Invoice Amount ','',false);
        }
        else if(this.form.controls.invoiceAmount.value == 0){
          this.commonUtility.alertMsg('Invoice Amount Should Not be Zero','',false);

        }
        else if (!this.checkboxValue) {
          this.commonUtility.alertMsg('Please Accept Terms & Conditions', '', false);
          return;
         }    
        else{
        if (this.form.invalid ) {
          return;
        }
    
    
        let req = {
          'firstName': this.form.controls.firstName.value.toString(),
          'lastName': this.form.controls.lastName.value.toString(),
          'emailId': this.form.controls.emailId.value.toString(),
         'companyName': this.form.controls.companyName.value.toString(),
         'mobileNo' : this.form.controls.mobileNo.value.toString(),
         'customerId': this.form.controls.customerId.value.toString(),
         'invoiceNumber': this.form.controls.invoiceNumber.value.toString(),
         'invoiceAmount': this.form.controls.invoiceAmount.value.toString(),
         'source': 'Trimble'
          };
        
    //const encodedCaptcha = btoa(this.form.controls.captcha.value);

    this.categoryService.submitTrimbleDetails(req).subscribe(res =>  {
          if(res.body.statusCode === "00000")
          {
           this.tranxnForm.controls.EncData.setValue(res.body.data.fields.EncData);
           this.tranxnForm.controls.MerchantId.setValue(res.body.data.fields.MerchantId);
           this.tranxnForm.controls.BankId.setValue(res.body.data.fields.BankId);
           this.tranxnForm.controls.TerminalId.setValue(res.body.data.fields.TerminalId);
           this.tranxnForm.controls.Version.setValue(res.body.data.fields.Version);
           this.tranxnForm.controls.TransactionId.setValue(res.body.data.fields.TransactionId);
           this.tranxnForm.controls.emailId.setValue(res.body.data.fields.emailId);
           this.tranxnForm.controls.mobileNo.setValue(res.body.data.fields.mobileNo);
           this.tranxnForm.controls.firstName.setValue(res.body.data.fields.firstName);
           this.tranxnForm.controls.lastName.setValue(res.body.data.fields.lastName);
           
    
           this.EncDataField  	= res.body.data.fields.EncData;
           this.MerchantIdField = res.body.data.fields.MerchantId;
           this.BankIdField = res.body.data.fields.BankId;
           this.TerminalIdField = res.body.data.fields.TerminalId;
           this.VersionField = res.body.data.fields.Version ;
           this.txnForm.nativeElement.submit();
    
    
          }
          else{
           this.commonUtility.alertMsg(res.body.statusDesc,'',false);
          }
           this.loading = false;
                },
                (error)=>{  this.commonUtility.alertMsg(JSON.stringify(error.statusText) ,'',false);}
          )
        
      }
      
        }

hideError(controlName)
    {
      this.form.controls[controlName].markAsUntouched();
      if(this.submitBtnMsgClass && this.submitBtnMsgClass.indexOf("alertBlock")>-1)
      {  this.submitBtnMsgClass="wrapper"; }
      if(this.submitBtnMsg && this.submitBtnMsg.indexOf("a")>-1)
      { this.submitBtnMsg=""; }
    }  
    
    // ValidCaptcha(){
    //   let str1=this.initialCap
    //   let str2=this.form.get('captcha').value;
    //   if(str2.toUpperCase()!="") {
    //   if(str1 == str2.toUpperCase()){
    //     this.form.controls['captcha'].setErrors(null);
    //     return true;
    //   }else{
    //     this.form.controls['captcha'].setErrors({'incorrectcaptcha': true});
    //     return false;
    //   }
    //   }
    //   else {
    //     this.commonUtility.alertMsg('Please try again invalid Captcha','',false);
    //   }
    // }

    // Cap() {
    //   let alpha = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    //    var apl1 = alpha[Math.floor(Math.random() * 36)];
    //    var apl2 = alpha[Math.floor(Math.random() * 36)];
    //    var apl3 = alpha[Math.floor(Math.random() * 36)];
    //    var apl4 = alpha[Math.floor(Math.random() * 36)];
    //    var apl5 = alpha[Math.floor(Math.random() * 36)];
    //    var apl6 = alpha[Math.floor(Math.random() * 36)];
    //    this.initialCap = apl1 + apl2 + apl3 + apl4 + apl5 + apl6;
  
    //    }
}




